import {OrderLineSticker} from '../../transport/apiServiceResponse';

import {UserPriceState} from './types';

type DisplayRules = {
  presentAsPublicMemberProduct: boolean;
  presentAsPrivateMemberProduct: boolean;
};

export function filterStickersByEligibility(
  stickers: OrderLineSticker[],
  userState: UserPriceState,
  displayRules: DisplayRules,
): OrderLineSticker[] {
  return stickers.filter(sticker => {
    if (
      sticker.sticker_type === 'private_loyalty_member' &&
      !(userState.privatePricing && displayRules.presentAsPrivateMemberProduct)
    ) {
      return false;
    }
    if (
      // DIS-1590: MFL sends this sticker to a session-less caller with the member
      // price printed on it, so it is an advert. It follows the store, not the
      // shopper's entitlement.
      sticker.sticker_type === 'public_loyalty_member' &&
      !(userState.storeLoyaltyEnabled && displayRules.presentAsPublicMemberProduct)
    ) {
      return false;
    }
    return true;
  });
}
